// src/dashboard/components/UserSelectionModal.js

import React, { useState, useEffect } from 'react';

const UserSelectionModal = ({ isOpen, onClose, allUsers, selectedUsers, onConfirm, styles }) => {
    const [tempSelectedUsers, setTempSelectedUsers] = useState(selectedUsers);

    useEffect(() => {
        if (isOpen) {
            setTempSelectedUsers(selectedUsers);
        }
    }, [isOpen, selectedUsers]);

    if (!isOpen) return null;

    const handleCheckboxChange = (userId) => {
        const newSelection = tempSelectedUsers.includes(userId)
            ? tempSelectedUsers.filter(id => id !== userId)
            : [...tempSelectedUsers, userId];
        setTempSelectedUsers(newSelection);
    };

    const handleConfirm = () => {
        onConfirm(tempSelectedUsers);
        onClose();
    };

    const selectAll = () => setTempSelectedUsers(allUsers.map(u => u.id));
    const clearAll = () => setTempSelectedUsers([]);

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={`${styles.modalContent} ${styles.card}`} onClick={e => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.cardTitle}>Selecionar Funcionários</h3>
                    <button className={styles.modalCloseButton} onClick={onClose}>×</button>
                </div>
                <div className={styles.modalActions}>
                    <button className={styles.modalActionButton} onClick={selectAll}>Selecionar Todos</button>
                    <button className={styles.modalActionButton} onClick={clearAll}>Limpar Seleção</button>
                </div>
                <div className={styles.modalBody}>
                    {allUsers.map(user => (
                        <label key={user.id} className={styles.userCheckboxLabel}>
                            <input
                                type="checkbox"
                                checked={tempSelectedUsers.includes(user.id)}
                                onChange={() => handleCheckboxChange(user.id)}
                            />
                            {user.nome}
                        </label>
                    ))}
                </div>
                <div className={styles.modalFooter}>
                    <button className={`${styles.tabButton}`} onClick={onClose}>Fechar</button>
                    <button className={`${styles.tabButton} ${styles.activeTab}`} onClick={handleConfirm}>Confirmar</button>
                </div>
            </div>
        </div>
    );
};

export default UserSelectionModal;